<template>
  <div class="content">
    <form>
      <initial-form :datas="dataall"></initial-form>
      <firma></firma>
      <sklad :datas="dataall"></sklad>
      <paytype :datas="dataall"></paytype>
      <b-modal id="modal-close" centered>
        <h4>
          {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
        </h4>
  
        <template #modal-footer="{ ok, cancel, hide }">
          <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
            @click="$root.$refs.initial.Savedokument()">{{$t('Да')}}</button>
          <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
          <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
        </template>
      </b-modal>
    </form>
  </div>
</template>
<script>
import { InitialForm, Firma, Sklad, Paytype } from "@/pages";
export default {
  components: {
    InitialForm,
    Firma,
    Sklad,
    Paytype
  },
  methods:{
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Начальный остаток" });
      }
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  created: function() {
    let self=this;
    axios
        .get("api/v1/initial-balance/last-number")
        .then(function(response) {
            self.dataall.number=response.data.number;
        });
        axios
        .get("api/v1/dollar-exchange-rate/last")
        .then(function(response) {
            self.dataall.dollar_rate=response.data.rate;
        });
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved<4) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  },
  data() {
    return {
      dataall: {
        created_at: new Date()
          .valueOf()
          .toString()
          .slice(0, 10),
        create_time: new Date().toISOString().slice(0, 10),
        updated_at: new Date()
          .valueOf()
          .toString()
          .slice(0, 10),
        sklad_id: parseInt(localStorage.getItem("sklad_id")),
        user_id: parseInt(localStorage.getItem("user_id")),
        dollar_rate:0,
        pay_type_id: 1,
        summa: 0,
        debit_summa: 0,
        comment: "",
        number:0,
        count_all: 0,
        initial_balance_table: [
          {
            shtrix_kod:"",
            product: {extra_name:""},
            product_id: 0,
            count: 0,
            debit_price: 0,
            debit_summa:0,
            chakana_percent: 0,
            optom_percent: 0,
            chakana_price: 0,
            optom_price: 0,
            chakana_summa: 0,
            optom_summa: 0,
            pack_count:0,
            pack_price:0,
            pack_norma:0
          }
        ]
      }
    };
  }
};
</script>
